import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  public pruebaaaaa;
 //public api: string = "http://192.168.1.244/virso/profesionales20/apiv6/";
// public apitpv: string = "http://192.168.1.161/webs/2021/clubinter_comerciales/admin/tpv/";
  public apitpv: string = "https://www.clubinter.es/profesionalesv2/tpv/";
  public api: string = "https://www.clubinter.es/profesionalesv2/apiv6/";
  public usuario;
  public club;
  public carrito = [];
  public plantillascarrito = [];
  public presupuesto = [];
  public cabecera_pedido: { descripcion?: '',comentario?: '',comentario_logistica?: ''
  } = {};

  constructor(private http: HttpClient) { }
  public comprueba_carrito() {
    var clientecarritotemporal = JSON.parse(localStorage.getItem('clientecarrito'));
    var carritoarticulostemporal = JSON.parse(localStorage.getItem('articulocarrito'));
    var carritoplantillastemporal = JSON.parse(localStorage.getItem('plantillascarrito'));
    if (carritoarticulostemporal != "" && carritoarticulostemporal != null) {
      this.carrito = carritoarticulostemporal;
      console.log('carrito temporal');
    } else {
      console.log('no carrito temporal');
    }
    if (carritoplantillastemporal != "" && carritoplantillastemporal != null) {
      this.plantillascarrito = carritoplantillastemporal;
      console.log('plantillascarrito carrito temporal');
    } else {
      console.log('no plantillascarrito carrito temporal');
    }
    if (clientecarritotemporal != "" && clientecarritotemporal != null) {
      this.club = clientecarritotemporal;
      console.log('carrito temporal');
    } else {
      console.log('no carrito temporal');
    }
  }
  carga_permiso(permiso) {
    if (this.usuario.permisos.length > 0) {
      var resultado = this.usuario.permisos.filter(mipermiso => mipermiso.permiso == permiso);

      if (resultado.length > 0) {
        return true;
      } else {
        return false;
      }

    } else {
      return false;
    }

  }
  //DEVUELVE LOS DATOS DE CLUBINTER
  public datos_empresa(): Observable<any> {
    let parametros = {
      token: this.usuario.token
    };
    console.log(parametros);
    return this.http.post(this.api + 'empresa/detalle.php', parametros).map(
      (response) => {
        return response[0];
      }
    );
  }
   //DEVUELVE LOS DATOS DE configuracion de portes
   public configuracion(): Observable<any> {
    let parametros = {
      token: this.usuario.token
    };
    console.log(parametros);
    return this.http.post(this.api + 'config/detalle.php', parametros).map(
      (response) => {
        return response[0];
      }
    );
  }
   //DEVUELVE EL IVA
   public datosiva(): Observable<any> {
    let parametros = {
      token: this.usuario.token
    };
    console.log(parametros);
    return this.http.post(this.api + 'iva/detalle.php', parametros).map(
      (response) => {
        return response[0];
      }
    );
  }
  //DEVUELVE LOS PRESUPUESTOS DE UN COMERCIAL PARA EL PANEL
  public resumen_presupuestos(usuario): Observable<any> {
    let parametros = {
      token: this.usuario.token,
      usuario:usuario
    };
    console.log(parametros);
    return this.http.post(this.api + 'panel/lista_presupuestos.php', parametros).map(
      (response) => {
        return response[0];
      }
    );
  }
  //DEVUELVE LOS TODOS LOS PRESUPUESTOS DE UN COMERCIAL POR ESTADO Y AÑO
  public resumen_presupuestos_estado(usuario,estado,year): Observable<any> {
    let parametros = {
      token: this.usuario.token,
      usuario:usuario,
      estado:estado,
      year:year
    };
    console.log(parametros);
    return this.http.post(this.api + 'panel/lista_graficos_presupuestos.php', parametros).map(
      (response) => {
        return response[0];
      }
    );
  }
  //DEVUELVE LOS TODOS LOS pagos de un club
  public resumen_pagos(club): Observable<any> {
    let parametros = {
      token: this.usuario.token,
      club:club
      
    };
    console.log(parametros);
    return this.http.post(this.api + 'panel/lista_pagos.php', parametros).map(
      (response) => {
        return response[0];
      }
    );
  }
  //DEVUELVE LOS TODOS LOS facturas de un club
  public resumen_facturas(club): Observable<any> {
    let parametros = {
      token: this.usuario.token,
      club:club
      
    };
    console.log(parametros);
    return this.http.post(this.api + 'panel/lista_facturas.php', parametros).map(
      (response) => {
        return response[0];
      }
    );
  }
   //DEVUELVE LOS TODOS LOS peedidos de un club
   public resumen_pedidos(club): Observable<any> {
    let parametros = {
      token: this.usuario.token,
      club:club
      
    };
    console.log(parametros);
    return this.http.post(this.api + 'panel/lista_pedidos_pendientes.php', parametros).map(
      (response) => {
        return response[0];
      }
    );
  }

  //DEVUELVE LOS TODOS LOS PRESUPUESTOS DE UN COMERCIAL POR ESTADO Y AÑO
  public resumen_pedidos_grafico(club,year): Observable<any> {
    let parametros = {
      token: this.usuario.token,
      club:club,
      year:year
    };
    console.log(parametros);
    return this.http.post(this.api + 'panel/lista_graficos_pedidos.php', parametros).map(
      (response) => {
        return response[0];
      }
    );
  }

  getImage(imageUrl: string): Observable<any> {
    let parametros = {
      imagen:imageUrl
    };
console.log(parametros);
console.log('manda');
    return this.http.post('https://www.clubinter.es/imagen_tienda_clubs/existe.php',parametros).map(
      (response) => {
        
        return response[0];
      });
  }

  public envia_incidencia(incidencia): Observable<any> {
    let parametros = {
      token: this.usuario.token,
      titulo:incidencia.titulo,
      descripcion:incidencia.descripcion,
      claveusuario:this.usuario.clave
    };
    console.log(parametros);
    return this.http.post(this.api + 'incidencias/insert.php', parametros).map(
      (response) => {
        return response[0];
      }
    );
  }
 
  
}
